module.exports = __webpack_public_path__ + "static/media/257557_12big.c019c372.jpg";